let locationHeader = '';

export const setLocationHeader = (value: string) => {
  if (typeof window !== 'undefined') {
    locationHeader = value;
  }
};

export const getLocationHeader = locationHeader;

const getUserAgent = (ctx: any) => {
  if (locationHeader) {
    return { 'x-ipcountry': locationHeader };
  }

  if (ctx && ctx.req && ctx.req.headers['cf-ipcountry']) {
    return { 'x-ipcountry': ctx.req.headers['cf-ipcountry'] };
  }

  return {};
};

export default getUserAgent;
